import {
    boolean,
    string,
} from 'vue-mc/validation';
import Model from './Model';
import Collection from './Collection';
import { User } from './User';

export class Card extends Model {

	defaults() {
		return {
			accountId: null,
			token: null,
		};
	}

	routes() {
		return {
			create: '/accounts/{accountId}/card',
		};
	}

	options() {
		return {
			patch: true,
		};
	}
}

/**
 * Account model
 * 
 * @param {number} id
 * @param {string} name
 * @param {Object} card
 * @param {Object} stats
 * @param {User[]} users
 * @param {boolean} hidden
 * @param {string} plan
 */
export class Account extends Model {
	
	defaults() {
		return {
			id: null,
			name: '',
			card: {
				brand: '',
				last4: null,
				exp_month: 0,
				exp_year: 0,
			},
			stats: {
				activeProjects: 0,
				activeReports: 0,
				archivedProjects: 0,
				archivedReports: 0,
				articlesLastThirtyDays: 0,
			},
			users: [],
			hidden: false,
			plan: '',
		};
	}
	
	validation() {
		return {
			name: string,
			hidden: boolean,
		};
	}
	
	routes() {
		return {
			fetch: '/accounts/{id}',
			patch: '/accounts/{id}',
			fetchUsers: '/accounts/{id}/users',
		};
	}

	options() {
		return {
			patch: true,
			methods: {
				fetchUsers: 'GET',
			},
		};
	}

	/**
	 * Method for custom route 'fetchUsers'
	 * @returns {Promise} Result of refetching users for this account
	 */
	fetchUsers() {
		const method = this.getOption('methods.fetchUsers');
		const route = this.getRoute('fetchUsers');
		const url = this.getURL(route, this.getRouteParameters());

		return new Promise((resolve, reject) => {
			this.loading = true;
			this.getRequest({ method, url, headers: { Authorization: '' } })
				.send()
				.then((resp) => {
					this.users = [];
					resp.response.data.forEach((user) => {
						this.users.push(new User(user));
					});
					resolve(resp);
				})
				.catch((e) => {
					reject(e);
				})
				.finally(() => {
					this.loading = false;
				});
		});
	}

}

export class Accounts extends Collection {

	model() {
		return Account;
	}

	routes() {
		return {
			fetch: '/accounts',
		};
	}
	
	hide() {
		let promises = [];
		this.each((account) => {
			account.hidden = true;
			promises.push(account.save());
		});
		return Promise.all(promises);
	}
	
	get visibleModels() {
		return this.models.filter(account => !account.hidden);
	}
	
	get hiddenModels() {
		return this.models.filter(account => account.hidden);
	}

}
